import {Component, Input, OnInit} from '@angular/core';
import {UpdateSelectedProcedure} from '../../../shared/store/actions/selected-procedure.actions';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {select, Store} from '@ngrx/store';
import {CustomerService} from '../../services/customer.service';
import {ConstsHelper} from '../../../../helpers/consts.helper';
import {CustomerInterfaceState} from '../../store/state/customer.state';
import {CustomerInterface} from '../../models/customer.interface';
import {
  ECheckPasswordActions,
  UpdateCheckPasswordVisibility,
  UpdateCheckPasswordVisibilitySuccess
} from '../../../shared/store/actions/check-password.actions';
import {UpdateCustomerMission} from '../../../shared/store/actions/customer-mission.actions';
import {ExtranetService} from '../../../shared/services/extranet.service';
import {RibInterface} from '../../models/rib.interface';
import {Actions, ofType} from '@ngrx/effects';

@Component({
    selector: 'app-update-iban',
    templateUrl: './update-iban.component.html',
    styleUrls: ['./update-iban.component.css'],
    standalone: false
})
export class UpdateIbanComponent implements OnInit {

  updateIbanForm: FormGroup;
  updateIbanFormSubmitted: boolean;
  acceptSepa: boolean;
  customer: CustomerInterface;
  action: string;

  errors: any = {
    iban: {
      required: `L'IBAN est requis.`,
      pattern: `L'IBAN saisie n'est pas valide.`
    },
    bic: {
      required: `Le BIC est requis.`,
      pattern: `Le BIC saisie n'est pas valide.`
    }
  };

  @Input()
  procedureCode: string;

  @Input()
  message: any;

  constructor(
      private formBuilder: FormBuilder,
      private store: Store<any>,
      private customerService: CustomerService,
      private extranetService: ExtranetService,
      private action$: Actions
  ) {}

  ngOnInit() {
    this.acceptSepa = false;
    this.store.pipe(select(ConstsHelper.REDUCER_CUSTOMER)).subscribe( (result: CustomerInterfaceState) => {
      if (null != result.customer) {
        this.customer = result.customer;
      }
    });

    this.action$.pipe(ofType(ECheckPasswordActions.UpdateCheckPasswordVisibilitySuccess)).subscribe((response: UpdateCheckPasswordVisibilitySuccess) => {
      if (
          response.payload != null &&
          (
              this.extranetService.getSupportUser() !== null &&
              response.payload.password == null
          ) ||
          (
              this.extranetService.getSupportUser() == null &&
              response.payload.password != null
          )
      ) {
        const param: RibInterface = {
          iban: this.updateIbanForm.get('iban').value,
          bic: this.updateIbanForm.get('bic').value,
          password: response.payload.password,
          linkedCustomerId: this.customer.id
        };
        this.customerService.updateRib(param).subscribe( responseUpdateIban => {
          if (responseUpdateIban && responseUpdateIban.message === 'OK') {
            this.message.iban = this.updateIbanForm.get('iban').value;
            this.message.bic = this.updateIbanForm.get('bic').value;
            this.message.strict = true;
            this.message.amount = this.message.data.amount;
            this.message.extKey = this.message.data.ext_key;
            this.message.reason = this.message.data.reason;
            this.message.requestPid = this.message.data.request_pid;

            // update customer mission for mission manager
            this.store.dispatch(new UpdateCustomerMission(this.message, this.procedureCode, 'account'));
          }
        });
      }
    });

    this.initUpdateIbanForm();
  }

  initUpdateIbanForm() {
    this.updateIbanForm = this.formBuilder.group({});
    this.updateIbanForm.addControl('iban', this.formBuilder.control('', [Validators.required]));
    this.updateIbanForm.addControl('bic', this.formBuilder.control('', [Validators.required, Validators.pattern(ConstsHelper.bicPattern)]));
  }

  cancel() {
    this.store.dispatch(new UpdateSelectedProcedure(''));
  }

  setSepa($event) {
    this.acceptSepa = $event.target.checked;
  }

  saveIban() {
    this.updateIbanFormSubmitted = true;

    if (this.updateIbanForm.valid && this.acceptSepa) {
      this.updateIbanFormSubmitted = false;
      if (this.extranetService.getSupportUser()) {
        this.store.dispatch(new UpdateCheckPasswordVisibilitySuccess({visibility: false, isValid: true, password: null, page: ''}));
      } else {
        this.store.dispatch(new UpdateCheckPasswordVisibility({
          visibility: true,
          isValid: null,
          password: null,
          page: ''
        }));
      }
    }
  }

  getError(formControlName: string): string {
    let errorMsg = '';
    if (this.updateIbanForm.controls[formControlName].invalid) {
      Object.keys(this.updateIbanForm.controls[formControlName].errors).map(
          key => {
            errorMsg = this.errors[formControlName][key];
          }
      );
    }
    return errorMsg;
  }
}
